import * as Yup from 'yup';

export const UpdateEventSchema = Yup.object({
  templateId: Yup.string().trim().required('Este campo es requerido'),
  title: Yup.string().trim().required('Este campo es requerido'),
  startDate: Yup.date().required('Este campo es requerido'),
  time: Yup.string().trim().required('Este campo es requerido'),
  description: Yup.string()
    .trim()
    .optional()
    .max(500, 'El tamaño debe ser menor a 500 caracteres'),
  duration: Yup.string().required('Este campo es requerido'),
  address: Yup.string().trim().optional(),
  link: Yup.string()
    .trim()
    .url('Ingrese una URL válida Ej. http://www.ejemplo.com')
    .optional(),
  guests: Yup.array()
    .of(
      Yup.object({
        value: Yup.string().trim(),
        label: Yup.string().trim(),
      }),
    )
    .optional(),
  note: Yup.string().trim().optional(),
});
